module.exports = __webpack_public_path__ + "media/customizations/sevenhills/back-367d4a7a79a3291911c19eb3e73eb22a.jpg";